define( function() {
	"use strict";

	return ( /^(?:checkbox|radio)$/i );
} );



//////////////////
// WEBPACK FOOTER
// ./node_modules/jquery/src/var/rcheckableType.js
// module id = 89
// module chunks = 0